var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOneoWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.97345C0 7.42157 0 7.14563 0.0740273 6.89151C0.139601 6.66641 0.247366 6.4547 0.392027 6.26677C0.555337 6.05461 0.782021 5.8852 1.23539 5.54638L8.0177 0.477696C8.36902 0.215138 8.54468 0.0838583 8.73865 0.0333949C8.9098 -0.0111316 9.0902 -0.0111316 9.26135 0.0333949C9.45532 0.0838583 9.63098 0.215138 9.98231 0.477697L16.7646 5.54638C17.218 5.8852 17.4447 6.05461 17.608 6.26677C17.7526 6.4547 17.8604 6.66641 17.926 6.89151C18 7.14563 18 7.42157 18 7.97345V14.9252C18 16.0015 18 16.5396 17.782 16.9507C17.5903 17.3123 17.2843 17.6063 16.908 17.7905C16.4802 18 15.9201 18 14.8 18H3.2C2.0799 18 1.51984 18 1.09202 17.7905C0.715695 17.6063 0.409734 17.3123 0.217987 16.9507C0 16.5396 0 16.0015 0 14.9252V7.97345Z",
    fill: "#FDE0E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_415_192422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 9.75V8.6C14 8.03995 14 7.75992 13.891 7.54601C13.7951 7.35785 13.6422 7.20487 13.454 7.10899C13.2401 7 12.96 7 12.4 7H6.6C6.03995 7 5.75992 7 5.54601 7.10899C5.35785 7.20487 5.20487 7.35785 5.10899 7.54601C5 7.75992 5 8.03995 5 8.6V13.4C5 13.9601 5 14.2401 5.10899 14.454C5.20487 14.6422 5.35785 14.7951 5.54601 14.891C5.75992 15 6.03995 15 6.6 15L12.4 15C12.9601 15 13.2401 15 13.454 14.891C13.6422 14.7951 13.7951 14.6422 13.891 14.454C14 14.2401 14 13.9601 14 13.4V12.25M11.5 11C11.5 10.7677 11.5 10.6515 11.5192 10.5549C11.5981 10.1582 11.9082 9.84812 12.3049 9.76921C12.4015 9.75 12.5177 9.75 12.75 9.75H13.75C13.9823 9.75 14.0985 9.75 14.1951 9.76921C14.5918 9.84812 14.9019 10.1582 14.9808 10.5549C15 10.6515 15 10.7677 15 11C15 11.2323 15 11.3485 14.9808 11.4451C14.9019 11.8418 14.5918 12.1519 14.1951 12.2308C14.0985 12.25 13.9823 12.25 13.75 12.25H12.75C12.5177 12.25 12.4015 12.25 12.3049 12.2308C11.9082 12.1519 11.5981 11.8418 11.5192 11.4451C11.5 11.3485 11.5 11.2323 11.5 11Z",
    stroke: "url(#paint0_linear_415_192422)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_415_192422",
    x: 3,
    y: 4,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.423529 0 0 0 0 0.0392157 0 0 0 0 0.109804 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_415_192422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_415_192422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_415_192422",
    x1: 5,
    y1: 7,
    x2: 15.169,
    y2: 7.22098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4112E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneoWallet);
export default __webpack_public_path__ + "static/media/OneoWallet.73327e6c7c215707f51d25df70898bc8.svg";
export { ForwardRef as ReactComponent };